import { MgService } from 'src/app/services/mg.service';
import { Attachment } from '../../../models/attachment.model';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-call-attachments',
  templateUrl: './call-attachments.component.html',
  styleUrls: ['./call-attachments.component.scss']
})
export class CallAttachmentsComponent implements OnInit {
  @Input() files: Attachment[];
  @Input() userType: string;

  private acceptMimeTypes = [
    "image/x-png",
    "image/png",
    "image/gif",
    "image/jpeg",
    "application/pdf",
    "application/json",
    "application/xml",
    "image/webp",
    "text/xml",
    ".png",
  ];

  constructor(
    private mg: MgService
  ) { }

  ngOnInit(): void {
  }

  public downloadFile(file: Attachment) {
    this.mg.downloadCallFile(file.path)
    .subscribe(
      res => {
        const blob = new Blob([res], { type: res.type });
        var downloadURL = window.URL.createObjectURL(blob);
        var link = document.createElement('a');

        if(this.acceptMimeTypes.includes(res.type)) {
          window.open(downloadURL);
        } else {
          link.href = downloadURL;
          link.download = file.name;
          link.click();
        }
      }
    )
  }
}
